export default __webpack_public_path__ + "static/media/01__o_3.b0e3b32a.jpg";